import { render, staticRenderFns } from "./CorreccioOrdreEixida.vue?vue&type=template&id=022f2467&scoped=true"
import script from "./CorreccioOrdreEixida.vue?vue&type=script&lang=js"
export * from "./CorreccioOrdreEixida.vue?vue&type=script&lang=js"
import style0 from "./CorreccioOrdreEixida.vue?vue&type=style&index=0&id=022f2467&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022f2467",
  null
  
)

export default component.exports